import { lazy, Suspense } from 'react';
const Receiver = lazy(() => import('./CastReceiver'));
export const CastRoute = () => (
  <Suspense fallback={<div>PresentR laden…</div>}>
    <Receiver />
  </Suspense>
);
